/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var SecRelatedInvInqSectionView = require('../views/SecRelatedInvInqSectionView');
var GetInvestigationInquiriesByObject = require('../services/GetInvestigationInquiriesByObject');

module.exports = {
  channel: 'sc',

  event: 'build:related-inv-inq-section-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: builRelatedInvInqSectionView(data)
    });
  }
};

function builRelatedInvInqSectionView(data) {
  var deferred = $.Deferred();
  GetInvestigationInquiriesByObject(data)
    .done(function(invinqs) {
      deferred.resolve(
        new SecRelatedInvInqSectionView({
          collection: new PageableCollection(invinqs, { pageSize: 25 })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
